import { DateInputV2 } from "@inputs/date/DateInputV2";
import { Box, Stack, Switch, Typography } from "@mui/material";
import { skipWeekend } from "@root/utils/date/skipWeekend";
import { useI18nContext } from "@root/utils/organisation";
import { set } from "date-fns";
import { useEffect } from "react";
import { useModalOfferContext } from "../../../context";
import { ContractDurationInput } from "../../contractDuration";
import { ContractDurationStack, SuiviStack, classes } from "./styles";

export const Success = () => {
  const { apply, setApply, offer, followUpDate, setFollowUpDate } = useModalOfferContext();
  const { timeZone } = useI18nContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: setApply is stable
  useEffect(() => {
    if (offer.startDate) {
      const date = new Date(offer.startDate);
      setApply((apply) => ({
        ...apply,
        contractStartDate: set(date, { hours: 10, minutes: 0, seconds: 0, milliseconds: 0 }).toISOString(),
      }));
    }
  }, [offer.startDate]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: setFollowUpDate is stable
  useEffect(() => {
    if (apply.isFollowUpGenerated && apply.contractStartDate) {
      const startDate = new Date(apply.contractStartDate);
      const followUpDate = new Date(startDate.setMonth(startDate.getMonth() + 1));
      setFollowUpDate(skipWeekend(followUpDate));
    }
  }, [apply.isFollowUpGenerated, apply.contractStartDate]);

  return (
    <>
      <ContractDurationStack className={classes.rootContract}>
        <DateInputV2
          label="Date début contrat *"
          value={apply.contractStartDate ? new Date(apply.contractStartDate) : null}
          onChange={(date) => {
            if (!date) {
              return;
            }
            setApply((apply) => ({
              ...apply,
              contractStartDate: set(date, { hours: 10, minutes: 0, seconds: 0, milliseconds: 0 }).toISOString(),
            }));
          }}
          TextFieldProps={{ id: "hiring-date", size: "small", placeholder: "Saisissez une date" }}
          timeZone={timeZone}
        />
        <Stack className={classes.cddStack}>
          {offer.contractType && !offer.contractType.includes("cdi") && <ContractDurationInput />}
        </Stack>
      </ContractDurationStack>

      <SuiviStack className={classes.rootSuivi}>
        <Box>
          <Typography variant="body1Bold">Souhaitez-vous générer une action de suivi en emploi ?</Typography>
          <Typography variant="body1">Vous pourrez la retrouver sur la fiche candidat</Typography>
        </Box>
        <Switch
          checked={!!apply.contractStartDate && !!offer.contractType && apply.isFollowUpGenerated}
          onChange={() => setApply((apply) => ({ ...apply, isFollowUpGenerated: !apply?.isFollowUpGenerated }))}
          color="primary"
          disabled={!apply.contractStartDate || !offer.contractType}
        />
      </SuiviStack>
      {apply.contractStartDate && offer.contractType && apply.isFollowUpGenerated && (
        <DateInputV2
          label="Date de prochain suivi"
          value={followUpDate instanceof Date ? followUpDate : followUpDate ? new Date(followUpDate) : null}
          onChange={(date) => setFollowUpDate(date)}
          timeZone={timeZone}
        />
      )}
    </>
  );
};
